/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { useUrlGenerator } from '../../contexts/RoutesContext';

import CountryField from '../fields/Country';
import RadioField from '../fields/Radio';
import NormalButton from '../buttons/Normal';

import { sendEvent } from '../../lib/analytics';

import styles from '../../../styles/forms/default.module.scss';

const propTypes = {
    initialValue: PropTypes.shape({
        country: PropTypes.string,
    }),
    onSuccess: PropTypes.func,
};

const defaultProps = {
    initialValue: {},
    onSuccess: null,
};

const CountryForm = ({ initialValue, onSuccess }) => {
    const url = useUrlGenerator();
    const { country: initialCountry = null } = initialValue || {};
    const [country, setCountry] = useState(initialCountry);

    useEffect(() => {
        setCountry(initialCountry);
    }, [setCountry, initialCountry]);

    const postForm = useCallback(() => {
        sendEvent('click', 'provenance', country, 1);

        if (onSuccess !== null) {
            onSuccess(country);
        }
    }, [country, onSuccess]);

    const onCanadaChange = useCallback(() => setCountry('CA'), [setCountry]);
    const onMartiniqueChange = useCallback(() => setCountry('MQ'), [setCountry]);
    const onOtherChange = useCallback((value) => setCountry(value), [setCountry]);

    return (
        <form className={styles.container} action={url('login')} method="post" onSubmit={postForm}>
            <div className={styles.fieldsGroup}>
                <RadioField
                    className={styles.field}
                    name="Canada"
                    value={country}
                    checked={country === 'CA'}
                    onChange={onCanadaChange}
                >
                    <FormattedMessage
                        id="content.country.checkbox_quebec_canada"
                        defaultMessage="Québec et Canada"
                        description="Checkbox"
                    />
                </RadioField>
                <RadioField
                    className={styles.field}
                    name="Martinique"
                    value={country}
                    checked={country === 'MQ'}
                    onChange={onMartiniqueChange}
                >
                    <FormattedMessage
                        id="content.country.checkbox_martinique"
                        defaultMessage="Martinique"
                        description="Checkbox"
                    />
                </RadioField>
                <CountryField
                    className={styles.field}
                    value={country || ''}
                    placeholder={{
                        id: 'content.country.field_other',
                        defaultMessage: 'Autre pays',
                        description: 'Placeholder',
                    }}
                    onChange={onOtherChange}
                />
                <NormalButton disabled={country === null} onClick={postForm}>
                    <FormattedMessage
                        id="content.country.continue"
                        defaultMessage="Continuer"
                        description="Button"
                    />
                </NormalButton>
            </div>
        </form>
    );
};
CountryForm.propTypes = propTypes;
CountryForm.defaultProps = defaultProps;

export default CountryForm;
